import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('@/pages/home/page'));
const AboutPage = lazy(() => import('@/pages/about/page'));
const ServicesPage = lazy(() => import('@/pages/services/page'));
const KasetliTentePage = lazy(() => import('@/pages/services/kasetli-tente/page'));
const KorukluTentePage = lazy(() => import('@/pages/services/koruklu-tente/page'));
const MafsalliTentePage = lazy(() => import('@/pages/services/mafsalli-tente/page'));
const TModelTentePage = lazy(() => import('@/pages/services/t-model-tente/page'));
const WinTentePage = lazy(() => import('@/pages/services/win-tente/page'));
const BioklimatikPergolaPage = lazy(() => import('@/pages/services/bioklimatik-pergola/page'));
const OtomatikPergolaPage = lazy(() => import('@/pages/services/otomatik-pergola/page'));
const RollingroofPergolaPage = lazy(() => import('@/pages/services/rollingroof-pergola/page'));
const SeffafBrandaPage = lazy(() => import('@/pages/services/seffaf-branda/page'));
const SeffafStorBrandaPage = lazy(() => import('@/pages/services/seffaf-stor-branda/page'));
const ZipPerdePage = lazy(() => import('@/pages/services/zip-perde/page'));
const ReferencesPage = lazy(() => import('@/pages/references/page'));
const FaqPage = lazy(() => import('@/pages/faq/page'));
const ContactPage = lazy(() => import('@/pages/contact/page'));
const KvkkPage = lazy(() => import('@/pages/kvkk/page'));
const CerezPolitikasiPage = lazy(() => import('@/pages/cerez-politikasi/page'));
const NotFound = lazy(() => import('@/pages/NotFound'));

const wrap = (el: JSX.Element) => <Suspense fallback={null}>{el}</Suspense>;

const routes: RouteObject[] = [
  { path: '/', element: wrap(<HomePage />) },
  { path: '/hakkimizda', element: wrap(<AboutPage />) },
  { path: '/hizmetler', element: wrap(<ServicesPage />) },
  { path: '/hizmetler/kasetli-tente', element: wrap(<KasetliTentePage />) },
  { path: '/hizmetler/koruklu-tente', element: wrap(<KorukluTentePage />) },
  { path: '/hizmetler/mafsalli-tente', element: wrap(<MafsalliTentePage />) },
  { path: '/hizmetler/t-model-tente', element: wrap(<TModelTentePage />) },
  { path: '/hizmetler/win-tente', element: wrap(<WinTentePage />) },
  { path: '/hizmetler/bioklimatik-pergola', element: wrap(<BioklimatikPergolaPage />) },
  { path: '/hizmetler/otomatik-pergola', element: wrap(<OtomatikPergolaPage />) },
  { path: '/hizmetler/rollingroof-pergola', element: wrap(<RollingroofPergolaPage />) },
  { path: '/hizmetler/seffaf-branda', element: wrap(<SeffafBrandaPage />) },
  { path: '/hizmetler/seffaf-stor-branda', element: wrap(<SeffafStorBrandaPage />) },
  { path: '/hizmetler/zip-perde', element: wrap(<ZipPerdePage />) },
  { path: '/referanslar', element: wrap(<ReferencesPage />) },
  { path: '/sss', element: wrap(<FaqPage />) },
  { path: '/iletisim', element: wrap(<ContactPage />) },
  { path: '/kvkk', element: wrap(<KvkkPage />) },
  { path: '/cerez-politikasi', element: wrap(<CerezPolitikasiPage />) },
  { path: '*', element: wrap(<NotFound />) },
];

export default routes;
